import React from "react"
import Container from "react-bootstrap/Container"
import { Row, Col } from "react-bootstrap"
import panelStyles from "./panel.module.scss"
import Reveal from "react-reveal/Reveal"
import Webapplication from "../../assets/webapplication.svg"
import Meeting from "../../assets/Meeting.svg"
import Responsive from "../../assets/responsive.svg"

const Panel = () => {
  return (
    <section
      className={`col-lg-9 col-md-12 col-sm-12 col-xs-12 mx-auto bg-light px-0 ${panelStyles.columWrapper}`}
    >
      <Container fluid className="px-0 pnlBorder">
        <Row className={`no-gutters panelBg`}>
          <Webapplication className="col-lg-6" />
          <Col lg={6} className="order-lg-1 my-auto p-4">
            <Reveal bottom forever={true}>
              <h2 className={`textGradent text-center pb-4`}>
                UI and UX Development
              </h2>
              <p>
                I can build user friendly interfaces by applying UI principles
                like easy to navigate, informative and visual consistency. I can
                build application with UX best design principles to achieve the
                end goals, increase traffic and conversion rate and with lower
                bounce rates.
              </p>
            </Reveal>
          </Col>
        </Row>
        <Row className={`no-gutters panelBg`}>
          <Responsive className="col-lg-6 order-lg-2" />
          <Col lg={6} className="order-lg-1 my-auto p-4">
            <Reveal bottom forever={true}>
              <h2 className={`textGradent text-center pb-4`}>
                Reaponsive Web <br /> Mobile Apps
              </h2>
              <p>
                Currently Mobile websites and mobile Apps are ruling the world.
                I can build Apps which are scalable to all LOT's. Some of the
                key factors like UX, page load time, accessibility, visual
                appeal, using optimised & responsive images are requirements in
                responsive design.
              </p>
            </Reveal>
          </Col>
        </Row>
        <Row className={`no-gutters panelBg`}>
          <Meeting className="col-lg-6" />
          <Col lg={6} className="order-lg-1 my-auto p-4">
            <Reveal bottom forever={true}>
              <h2 className={`textGradent text-center pb-4`}>
                Fast and Friendly Team Member
              </h2>
              <p>
                I can quickly adapt and mend with teams to achieve the final
                goal of a project. I can also learn new technologies and
                implement them in fast face of time if required. I am a good
                listner, speaker and content writer too.
              </p>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Panel
